import { render, staticRenderFns } from "./DesignBaseButton.vue?vue&type=template&id=04e94f76&"
import script from "./DesignBaseButton.vue?vue&type=script&lang=js&"
export * from "./DesignBaseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports